import { render, staticRenderFns } from "./LanguageCommunication.vue?vue&type=template&id=2db49034"
import script from "./LanguageCommunication.vue?vue&type=script&lang=ts"
export * from "./LanguageCommunication.vue?vue&type=script&lang=ts"
import style0 from "./LanguageCommunication.vue?vue&type=style&index=0&id=2db49034&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db49034')) {
      api.createRecord('2db49034', component.options)
    } else {
      api.reload('2db49034', component.options)
    }
    module.hot.accept("./LanguageCommunication.vue?vue&type=template&id=2db49034", function () {
      api.rerender('2db49034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/LanguageCommunication.vue"
export default component.exports